export enum MicrophoneKeys {
    MicrophoneInitializationDuration = "MicrophoneInitializationDuration",
    MicrophonePermissionsPreviouslyGranted = "MicrophonePermissionsPreviouslyGranted",
    MicrophoneSuccessfullyInitialized = "MicrophoneSuccessfullyInitialized",
    MicrophoneInitFailureReason = "MicrophoneInitFailureReason",
    MicrophonePermissionRetryDialogShown = "MicrophonePermissionRetryDialogShown",
    MicrophonePermissionRetryDailogTryAgainClicked = "MicrophonePermissionRetryDailogTryAgainClicked"
};